import { useEffect } from "react";

// Site URL is read from env at build time; falls back to window.location.origin so
// canonical/OG URLs still resolve during preview. Set REACT_APP_SITE_URL to the
// final production HTTPS domain when going live.
export function siteUrl() {
  if (typeof window !== "undefined" && process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}

function upsertMeta(key, value, attr = "name") {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, obj) {
  let el = document.head.querySelector(`script[data-jsonld-id="${id}"]`);
  if (obj === null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-jsonld-id", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export function useSeo({
  title,
  description,
  canonicalPath = "/",
  ogImage = "/og-image.png",
  jsonLd = null,
  jsonLdId = "page",
}) {
  useEffect(() => {
    document.title = title;
    const url = `${siteUrl()}${canonicalPath}`;
    const image = ogImage.startsWith("http") ? ogImage : `${siteUrl()}${ogImage}`;
    upsertMeta("description", description);
    upsertLink("canonical", url);
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:type", "website", "property");
    upsertMeta("og:url", url, "property");
    upsertMeta("og:site_name", "Financial Future Readiness Assessment", "property");
    upsertMeta("og:image", image, "property");
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);
    upsertMeta("twitter:image", image);
    upsertJsonLd(jsonLdId, jsonLd);
    return () => {
      upsertJsonLd(jsonLdId, null);
    };
  }, [title, description, canonicalPath, ogImage, jsonLd, jsonLdId]);
}
